import { MetricField } from "../../gql-generated/types";
import { useOrganicStatsTotal } from "../../lens-insights/hooks";
import { LensGranularity } from "../../lens-insights/models";

export interface HomeStatItem {
    value: string;
    diffValue: string | null;
}

export type HomeStats = Partial<Record<MetricField, HomeStatItem>>;

const homeMetricFields = [
    MetricField.LensActionSubscriberUniqueUsers,
    MetricField.LensViewers,
    MetricField.LensPlays,
    MetricField.LensShares,
];

export const useHomeStats = (): { stats: HomeStats; loading: boolean } => {
    const { totalMetrics, loading } = useOrganicStatsTotal({
        metricFields: homeMetricFields,
        defaultRange: LensGranularity.Lifetime,
    });

    const stats: HomeStats = {};

    for (const field of homeMetricFields) {
        const metric = totalMetrics?.[field];
        const diffValue = metric?.diffValue;

        stats[field] = {
            value: metric?.totalValueFormatted ?? "-",
            diffValue: diffValue && diffValue !== "-" ? diffValue : null,
        };
    }

    return { stats, loading };
};
